

/// <reference path="IntegratorMapping.ts" />

// Generated class IntegratorMappingValueType_ManagedObject

class IntegratorMappingValueType_ManagedObject extends IntegratorMapping
{

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }

    // Property: orderIndex
    set orderIndex(value:number) {
        this.setValueForKey(value, 'orderIndex');
    }
    get orderIndex():number {
        return this.valueForKey('orderIndex');
    }
    set orderIndexPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'orderIndex');
    }
    get orderIndexPrimitiveValue():number {
        return this.primitiveValueForKey('orderIndex');
    }

    // Property: title
    set title(value:string) {
        this.setValueForKey(value, 'title');
    }
    get title():string {
        return this.valueForKey('title');
    }
    set titlePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'title');
    }
    get titlePrimitiveValue():string {
        return this.primitiveValueForKey('title');
    }
    // Relationship: mappingInfo
    set mappingInfo(value:IntegratorMappingInfo) {
        this.setValueForKey(value, 'mappingInfo');
    }
    get mappingInfo():IntegratorMappingInfo {
        return this.valueForKey('mappingInfo') as IntegratorMappingInfo;
    }
}
